import { useMemo } from 'react';
import { Routes } from '@/routes';
import { AppIcons } from '@/components';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { envConfig } from '@/configs';

const iconClasses = 'text-[#58D36A] text-xl';

export default function useNavigationItems() {

  const [t] = useTranslation(['common']);

  return useMemo(() => {

    return [
      {
        path: Routes.UserWallet,
        title: t('common:labels.wallet'),
        icon: <AppIcons.OutlinePriceIcon className={iconClasses} />,
        hide: envConfig.ui.removeWallet
      },
      {
        path: Routes.UserMessages,
        title: t('common:labels.messages'),
        icon: <AppIcons.OutlineMessagesIcon className={iconClasses} />
      },
      /*
      {
        path: Routes.UserFeedbacks,
        title: t('common:labels.feedback'),
        icon: <AppIcons.OutlineFeedbackIcon className={iconClasses} />
      },
      */
      {
        path: Routes.UserProfile,
        title: t('common:labels.change-password'),
        query: { scope: 'password' },
        icon: <i className={`flaticon-password ${iconClasses}`} />,
        hide: envConfig.ui.removeChangePassword
      },
      {
        path: Routes.UserActivityReport,
        title: t('common:labels.activity-report'),
        icon: <i className={`flaticon-bar-chart ${iconClasses}`} />
      },
      {
        path: Routes.UserProfile,
        title: t('common:labels.settings'),
        icon: <AppIcons.OutlineSettingsIcon className={iconClasses} />
      },
      ...((!envConfig.ui.removeFAQ) ? [{
        path: Routes.FAQ,
        title: t('common:labels.common-questions'),
        icon: <QuestionCircleOutlined className={'text-[#58D36A] text-[19px]'} />
      }] : []),
    ];
  }, [t]);

}
